import { connect } from 'react-redux'
import { Media } from './Media.jsx'
import { getCurrentMediaType } from 'redux/mediaList/selectors'
import {
    isCurrentMediaSourceLoadedInDefaultFrame,
    isCurrentMediaViewable,
} from 'redux/currentMedia/selectors'
import { mainViewId } from 'redux/canvas/selectors'

const mapStateToProps = (state, ownProps) => ({
    type : getCurrentMediaType(state),
    isSourceLoaded: isCurrentMediaSourceLoadedInDefaultFrame(state),
    isViewable: isCurrentMediaViewable(state),
    id: mainViewId,
})

export const MediaContainer = connect(
    mapStateToProps,
)(Media)
